import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/696528f6c9f2cb0014128597_1782534376649_6add5723/redletterx_ai/src/components/common/VapiChatWidget.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/696528f6c9f2cb0014128597_1782534376649_6add5723/redletterx_ai/src/styles/index.css");
